export interface Note {
  id: number;
  date: string;
  title?: string;
  content: string;
  priority: 'normal' | 'important' | 'urgent';
  visibility: 'public' | 'private';
  contact_id?: number;
  contact_list_id?: number;
  created_by: number;
  updated_by?: number;
  created_at: string;
  updated_at: string;
  deleted_at?: string;
  creator_name?: string;
  updater_name?: string;
}

export interface CreateNoteData {
  date: string;
  title?: string;
  content: string;
  priority?: 'normal' | 'important' | 'urgent';
  visibility?: 'public' | 'private';
  contact_id?: number;
  contact_list_id?: number;
}

export interface UpdateNoteData {
  date?: string;
  title?: string;
  content?: string;
  priority?: 'normal' | 'important' | 'urgent';
  visibility?: 'public' | 'private';
  contact_id?: number;
  contact_list_id?: number;
}

export interface NoteQuery {
  date?: string;
  startDate?: string;
  endDate?: string;
  createdBy?: number;
  priority?: 'normal' | 'important' | 'urgent';
  visibility?: 'public' | 'private';
  page?: number;
  limit?: number;
  search?: string;
}

export interface NoteResponse {
  notes: Note[];
  pagination: {
    total: number;
    page: number;
    limit: number;
    pages: number;
  };
}

export interface NoteCount {
  date: string;
  count: number;
}

export interface NoteCounts {
  [date: string]: number;
}

// Note priority levels
export type NotePriority = 'normal' | 'important' | 'urgent';

// Note visibility levels
export type NoteVisibility = 'public' | 'private';

// Priority display names
export const PRIORITY_DISPLAY_NAMES: Record<NotePriority, string> = {
  normal: 'Normal',
  important: 'Important',
  urgent: 'Urgent'
};

// Priority colors
export const PRIORITY_COLORS: Record<NotePriority, string> = {
  normal: '#3b82f6',
  important: '#f59e0b',
  urgent: '#ef4444'
};

// Visibility display names
export const VISIBILITY_DISPLAY_NAMES: Record<NoteVisibility, string> = {
  public: 'Public',
  private: 'Private'
};

// Priority icons (using Material-UI icon names)
export const PRIORITY_ICONS: Record<NotePriority, string> = {
  normal: 'Info',
  important: 'Warning',
  urgent: 'Error'
}; 